import React from 'react'
// @ts-ignore no types
import { Text } from '../../elementals'
import classnames from 'classnames/bind'
import styles from './styles.scss'

const cx = classnames.bind(styles)

type EmptyStateProps = {
  title: string
  subtitle?: string
}
const EmptyState = ({ title, subtitle }: EmptyStateProps) => {
  return (
    <section className={cx('empty-text', 'u-text-center', 'u-mb-6', 'u-mt-6')}>
      <Text color='gray' as='h2' size='huge'>
        {title}
      </Text>
      {subtitle && (
        <Text color='gray' as='h3' size='big'>
          {subtitle}
        </Text>
      )}
    </section>
  )
}

export default EmptyState
